import { Link } from '~/components/common/link';
import { Button } from '~/components/ui/button';
import { cn, ctaLinkResolver } from '~/lib/utils';
import { Maybe } from '~/server/generated/contentful-graphql';

interface BlockFooterCTAProps {
  ctaHeadline?: Maybe<string>;
  ctaTitle?: Maybe<string>;
  ctaLink?: Maybe<string>;
  ctaLinkContentType?: Maybe<string>;
  ctaLinkContentSlug?: Maybe<string>;
  ctaLinkAssetUrl?: Maybe<string>;
  className?: string;
}

export function BlockFooterCTA({
  ctaHeadline,
  ctaLinkAssetUrl,
  ctaLink,
  ctaLinkContentType,
  ctaLinkContentSlug,
  ctaTitle,
  className,
}: BlockFooterCTAProps) {
  const ctaHref = ctaLinkResolver({ ctaLink, ctaLinkContentType, ctaLinkContentSlug, ctaLinkAssetUrl });

  if (!ctaHref) return null;

  return (
    <footer
      className={cn(
        'mx-auto mt-10 flex max-w-3xl flex-col items-center gap-y-5 text-center lg:mt-14 lg:gap-y-8',
        className,
      )}
    >
      {ctaHeadline && <div className='heading-sm text-balance'>{ctaHeadline}</div>}
      {ctaTitle && ctaHref && (
        <Button variant='outline' asChild>
          <Link href={ctaHref}>{ctaTitle}</Link>
        </Button>
      )}
    </footer>
  );
}
